import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import HeaderView from "./HeaderView";
import ViewDtls from "./ViewDtls";
import RelatedView from "./RelatedView";
import UseFetchData from "../../../hooks/UseFetchData";
import { PinDropSharp } from "@material-ui/icons";
import Session from "react-session-api";

const QuotationView = () => {
  //debugger;
  const classes = useStyles();
  const [QuotationMainData, setQuotationMainData] = useState([]);
  const [responsPayment, setresponsPayment] = useState([]);
  const [QuotationDtlsData, setQuotationDtlsData] = useState([]);
  const [QuotationNoteData, setQuotationNoteData] = useState([]);
  const [QuotationAttachData, setQuotationAttachData] = useState([]);
  const [QuotationImageData, setQuotationImageData] = useState([]);
  const [QuotationActivityData, setQuotationActivityData] = useState([]);
  const [ProductCount, setProductCount] = useState(0);
  const [AccountID, setAccountID] = useState('');
  const [AccountName, setAccountName] = useState('');
  const location = useLocation();
  const [responseViewDtls, fetchViewDtls] = UseFetchData();


  const getViewDtlsData = async () => {
    //debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("QuotationID", location.state.QuotationID);
    bodyFormData.append("UserID", Session.get("UID"));
    await fetchViewDtls("Quotation/View", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (responseViewDtls.Main !== undefined && responseViewDtls.Main.length > 0) {
      setQuotationMainData(responseViewDtls.Main);
      setAccountID(responseViewDtls.Main[0].AccountID);
      setAccountName(responseViewDtls.Main[0].AccountName);
    }
    if (responseViewDtls.QuotationDtls !== undefined && responseViewDtls.QuotationDtls.length > 0) {
      setQuotationDtlsData(responseViewDtls.QuotationDtls);
      setProductCount(responseViewDtls.QuotationDtls.length);
    }
    if (responseViewDtls.QuotationActivity !== undefined && responseViewDtls.QuotationActivity.length > 0) {
      setQuotationActivityData(responseViewDtls.QuotationActivity);
    }
    if (responseViewDtls.QuotationNotes !== undefined && responseViewDtls.QuotationNotes.length > 0) {
      setQuotationNoteData(responseViewDtls.QuotationNotes);
    }
    if (responseViewDtls.QuotationAttachments !== undefined && responseViewDtls.QuotationAttachments.length > 0) {
      setQuotationAttachData(responseViewDtls.QuotationAttachments);
    }
    if (responseViewDtls.QuotationImage !== undefined && responseViewDtls.QuotationImage.length > 0) {
      setQuotationImageData(responseViewDtls.QuotationImage);
    }
  }, [responseViewDtls]);

  useEffect(() => {
    getViewDtlsData();
  }, [])

  return (
    <Paper>
      <HeaderView
        QuotationID={location.state.QuotationID}
        QuotationMainData={QuotationMainData}
        PopulateData={getViewDtlsData}
        ProductCount={ProductCount}
        setProductCount={setProductCount}
      />
      <Grid container direction="row" className={classes.container}>
        <Grid sm={8} xs={12}>
          <Paper elevation={3} style={{ height: '100%' }}>
            <ViewDtls
              QuotationID={location.state.QuotationID}
              QuotationMainData={QuotationMainData}
              QuotationDtlsData={QuotationDtlsData}
              PopulateData={getViewDtlsData}
            />
          </Paper>
        </Grid>

        <Grid sm={4} xs={12}>
          <Paper elevation={3}>
            <h2 style={{ textDecoration: 'underline', textDecorationColor: '#0096FF', textDecorationThickness: 5, paddingLeft: 10 }}>RELATED</h2>
            <RelatedView
              QuotationID={location.state.QuotationID}
              QuotationMainData={QuotationMainData}
              QuotationNoteData={QuotationNoteData}
              QuotationAttachData={QuotationAttachData}
              QuotationImageData={QuotationImageData}
              QuotationActivityData={QuotationActivityData}
              ACID={AccountID}
              ACName={AccountName}
              PopulateData={getViewDtlsData}
            />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 7,
  },
}));

export default QuotationView;
